export default "__VITE_ASSET__BtbQbUFi__"